<template>
	<div class="welcomeContainer">
		<div class="panel grid grid-rows-[auto_1fr_auto] overflow-hidden">
			<div>
				<h2>Вітаємо на оновленому EcoCity ✨</h2>
	
				<div style="margin-bottom: 2em;">
					<p>
						Представляємо вам альфа-версію нашого нового вебсайту. Він все ще 
						перебуває в розробці тому деяких функцій тут може не вистачати.
					</p>
					<p>
						Ви все ще можете перейти на нашу 
						<a href="https://eco-city.org.ua">класичну версію сайту</a>.
					</p>
				</div>

				<h3>Останні оновлення</h3>
			</div>
			
			<div class="rounded-md overflow-y-auto">
				<ChangelogBlog/>
			</div>
			
			<div class="w-full flex justify-center mt-8">
				<button 
					class="text-md"
					@click="emit('closeClicked')"
				>
					Погнали дивитись
					<FontAwesomeIcon :icon="faPlay" style="margin-left: 0.3em;"/>
				</button>
			</div>
		</div>
	</div>
</template>

<script setup>
import { defineEmits } from 'vue'

import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import { faPlay } from '@fortawesome/free-solid-svg-icons'

import ChangelogBlog from './ChangelogBlog.vue';

const emit = defineEmits(['closeClicked'])
</script>

<style scoped>
.welcomeContainer {
	position: absolute;
	top: 0px;
	left: 0px; 

	width: 100%;
	height: 100%;

	z-index: 120;

	background-color: #000000AA;

	display: flex;
	align-items: center;
	justify-content: center;

	padding: 1em;

	box-sizing: border-box;
}

.panel {
	background-color: var(--color-background);
	border-radius: 10px;

	border: 1px solid var(--color-border);

	padding: 1.5em;
	padding-top: 1em;

	max-width: 34em;

	max-height: 90%;
}
</style>